import React from "react";
import { useTranslation } from "react-i18next";

const AgronomistInputContainer = ({ recommend, field2 }) => {
  const { i18n } = useTranslation();
  const isUrdu = i18n.language === "ur";

  return (
    <div
      style={{
        marginTop: "0.5rem",
        background: "linear-gradient(to bottom right, #d4edda, #c3e6cb)",
        width: "100%",
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          maxWidth: "50rem",
          margin: "0 auto",
          width: "90%",
          padding: "2rem",
          backgroundColor: "#fff",
          borderRadius: "0.75rem",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
          pageBreakAfter: "always",
          direction: isUrdu ? "rtl" : "ltr", // 🔥 Urdu support
          textAlign: "justify",
          lineHeight: 1.7,
        }}
      >
        {/* Title */}
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.8rem",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            color: "#155724",
          }}
        >
          {isUrdu ? "زرعی ماہر کی رائے" : "Agronomist Insights"}
        </h2>

        {/* Agronomist Inputs */}
        {[
          { label: isUrdu ? "تجویز" : "Recommendation", value: recommend, defaultText: "N/A" },
          { label: isUrdu ? "اضافی نوٹس" : "Additional Notes", value: field2, defaultText: "N/A" },
        ].map(({ label, value, defaultText }) => (
          <div
            key={label}
            style={{
              marginBottom: "1.5rem",
            }}
          >
            <h3
              style={{
                fontWeight: "bold",
                fontSize: "1.2rem",
                color: "#155724",
                marginBottom: "0.5rem",
                borderBottom: "2px solid #c3e6cb",
                paddingBottom: "0.25rem",
              }}
            >
              {label}:
            </h3>

            <p
              style={{
                color: "#333",
                whiteSpace: "pre-line", // ✅ Preserves line breaks for multi-paragraph input
                wordBreak: "break-word", // ✅ Prevents overflow for long words or mixed text
                fontSize: "1rem",
              }}
            >
              {value?.trim() ? value : defaultText}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AgronomistInputContainer;
